module.exports = __webpack_public_path__ + "e340a6ac61f7a704cbff8f400bb94da7.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/imgs/aroma-cat.png
 ** module id = 595
 ** module chunks = 0
 **/